"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
const CartRequestHandler_1 = require("../cart/requestHandlers/CartRequestHandler");
const EventEmitterFactory_1 = require("../events/EventEmitterFactory");
const CheckoutData_1 = require("./CheckoutData");
const PaymentFactory_1 = require("./Payment/PaymentFactory");
const CheckoutRequestHandler_1 = require("./requestHandlers/CheckoutRequestHandler");
const ShippingFactory_1 = require("./Shipping/ShippingFactory");
class Checkout {
    constructor(shopId, checkoutData, isBroadcastAllowed = false) {
        this.shopId = shopId;
        this.checkoutData = checkoutData;
        this.eventEmitter = EventEmitterFactory_1.EventEmitterFactory.getEmitter("CheckoutDidChangeEvent", isBroadcastAllowed);
        this.eventEmitter.on((payload) => {
            if (payload === this.checkoutData) {
                return;
            }
            this.checkoutData = payload;
        });
        this.getAvailableShippingOptions = this.getAvailableShippingOptions.bind(this);
        this.getAvailablePaymentOptions = this.getAvailablePaymentOptions.bind(this);
        this.purchase = this.purchase.bind(this);
        this.get = this.get.bind(this);
    }
    get hasNewsletter() {
        return this.checkoutData.hasNewsletter;
    }
    get customerRemark() {
        return this.checkoutData.customerRemark;
    }
    get checkoutId() {
        return this.checkoutData.checkoutId;
    }
    get orderId() {
        return this.checkoutData.orderId;
    }
    setCheckoutData(checkoutData) {
        this.checkoutData = checkoutData;
    }
    get cartData() {
        return this.checkoutData.cart;
    }
    get paymentId() {
        return this.checkoutData.paymentId;
    }
    get paymentTransaction() {
        return this.checkoutData.paymentTransaction;
    }
    get isCompleted() {
        return this.checkoutData.isCompleted;
    }
    get isValid() {
        return this.checkoutData.isValid;
    }
    get logisticsTypeId() {
        return this.checkoutData.logisticsTypeId;
    }
    get messages() {
        return this.checkoutData.messages;
    }
    get deliveryAddress() {
        return this.checkoutData.address.delivery;
    }
    get invoiceAddress() {
        return this.checkoutData.address.invoice;
    }
    get favouredDateShipping() {
        return this.checkoutData.favouredDateShipping;
    }
    get isPartDeliveryAllowed() {
        return this.checkoutData.isPartDeliveryAllowed;
    }
    get isGuest() {
        return this.checkoutData.isGuest;
    }
    get emitter() {
        return this.eventEmitter;
    }
    get tabInfo() {
        return this.emitter.tabInfo;
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const newCheckoutData = yield CheckoutRequestHandler_1.CheckoutRequestHandler.get(this.shopId, this.checkoutId);
            this.checkoutData = new CheckoutData_1.CheckoutData(newCheckoutData);
            this.eventEmitter.emit(this.checkoutData);
        });
    }
    put(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.cart) {
                yield CartRequestHandler_1.CartRequestHandler.putParams(this.shopId, this.cartData.cartId, data.cart);
                delete data.cart;
            }
            const newCheckoutData = yield CheckoutRequestHandler_1.CheckoutRequestHandler.putParams(this.shopId, this.checkoutId, data);
            this.checkoutData = new CheckoutData_1.CheckoutData(newCheckoutData);
            this.eventEmitter.emit(this.checkoutData);
        });
    }
    getAvailableShippingOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            return ShippingFactory_1.ShippingFactory.getShippingOptions(this.shopId, this.checkoutId);
        });
    }
    purchase(hasNewsletter) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.put({ buy: true, hasNewsletter });
        });
    }
    getAvailablePaymentOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            return PaymentFactory_1.PaymentFactory.getPaymentMethods(this.shopId, this.checkoutId);
        });
    }
}
exports.Checkout = Checkout;
